import React from "react";
import { SOCIAL_SOURCES } from "../../constants/app-constant";
import {
  FacebookIcon,
  FacebookWBIcon,
  InstagramIcon,
  InstagramWBIcon,
  LinkedInIcon,
  PinterestIcon,
  TwitterIcon,
  TwitterWBIcon,
  YoutubePlayIcon,
} from "../Icons/icons.component";

export default function SocialIcon({ type, showAll }) {
  const getIcon = (type) => {
    if (type == SOCIAL_SOURCES.FACEBOOK) {
      // return <FacebookIcon />;
      return <FacebookWBIcon />;
    } else if (type == SOCIAL_SOURCES.INSTAGRAM) {
      return <InstagramWBIcon />;
      // return <InstagramIcon />;
    } else if (type == SOCIAL_SOURCES.TWITTER) {
      return <TwitterWBIcon cla={"icon-place"} />;
      // return <TwitterIcon />;
    } else if (type == SOCIAL_SOURCES.YOUTUBE) {
      return <YoutubePlayIcon />;
    } else if (type == SOCIAL_SOURCES.LINKEDIN) {
      return <LinkedInIcon cla={"icon-place"} />
      // return <img
      //       src="https://backendportal.conceptbiu.com/assets/article_download/icons8-linkedin-30.png"
      //       alt="NA"
      //       width={25}
      //       height={25}
      //     />;
    } 
    // else if (type == SOCIAL_SOURCES.PINTEREST) {
    //   return <PinterestIcon />;
    // }
    return null;
  };
  if (showAll) {
    return <span>{Object.values(SOCIAL_SOURCES).map((t) => getIcon(t))}</span>;
  }
  if (Array.isArray(type)) {
    return <div className="platformLogos">{type.map((t) => getIcon(t))}</div>;
  } else {
    return getIcon(type);
  }
}
